// IconDwight — símbolo minimalista tech do assistente comercial.
// "D" outline arredondado, escalável e herda cor (currentColor).
// Pode ser usado em botões/headers; fica fluido em qualquer tamanho.
export default function IconDwight({ size = 18, color = 'currentColor', filled = false }: {
  size?: number;
  color?: string;
  filled?: boolean;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? color : 'none'}
      stroke={color}
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      {/* "D" minimalista: linha vertical + arco */}
      <path d="M6 4 L6 20 L12 20 A8 8 0 0 0 12 4 Z" />
      {/* Ponto interno minúsculo (toque tech) */}
      <circle cx="9" cy="12" r="0.8" fill={color} stroke="none" />
    </svg>
  );
}
